import { IonContent, IonIcon } from '@ionic/react';
import { lockClosed, flame } from 'ionicons/icons';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount.ts';
import { useCreateStripeClient } from '@/hooks/useCreateStripeClient.ts';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useTransBotInfo } from '@/pages/Onboarding/Layouts/OwnAI_Trans/hooks/useTransBotInfo.ts';
import { LayoutDataType } from '@/pages/Onboarding/Layouts/OwnAI_Trans/types.ts';
import { userService } from '@/services/user';
import { trackOnboardingComplete } from '@/utils/analytics';

import {
  PageStyles,
  Main,
  Badges,
  Badge,
  Title,
  Subtitle,
  ContentWrapper,
  BackgroundWrapper,
} from './SummaryScreen.styles';

export const SummaryScreen: React.FC = () => {
  const { refreshUser } = useAccount();
  const { createStripeClient, isCreatingStripeClient } =
    useCreateStripeClient();

  const form = useFormContext<LayoutDataType>();

  const formEmail = form.watch('email');

  const botInfo = useTransBotInfo('summary');

  const handleNextStep = async (): Promise<void> => {
    try {
      const lowerCaseEmail = formEmail.toLowerCase().trim();

      trackOnboardingComplete({ email: lowerCaseEmail });

      await createStripeClient(lowerCaseEmail);
      await userService.createOrUpdate({
        onboarding_data: {
          onboarded: true,
        },
      });

      refreshUser();
    } catch (error) {
      console.error('Can not create a stripe user', error);
    }
  };

  return (
    <PageStyles>
      <BackgroundWrapper backgroundImage={botInfo.imageUrl}>
        <IonContent className="summary-screen-content">
          <ContentWrapper>
            <Main>
              <Badges>
                <Badge variant="private">
                  <IonIcon icon={lockClosed} /> Private
                </Badge>
                <Badge variant="fire">
                  <IonIcon icon={flame} /> <IonIcon icon={flame} />{' '}
                  <IonIcon icon={flame} />
                </Badge>
              </Badges>
              <Title>{botInfo.name}</Title>
              <Subtitle>Matched all your preferences</Subtitle>
            </Main>
          </ContentWrapper>
        </IonContent>
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonRadius={'sm'}
          buttonSize={'large'}
          disabled={isCreatingStripeClient}
          buttonText="Start chatting"
        />
      </BackgroundWrapper>
    </PageStyles>
  );
};
